import api from '@/services/api'
import authHeader from '@/services/auth-header';

class CallHelper {
    parseLink(linkHeader) {
        const regex = /<(.*?)>.*? rel="(.*?)"/gmi
        let response = []
        let obj = {}

        while ((response = regex.exec(linkHeader)) !== null) {
            obj[response[2]] = response[1]
        }

        return obj;
    }

    async getDataRecursive(url, params, func, data = []) {
        const response = await api.get(url, {'params': params}, authHeader()).then(response => response)

        data = func(data, response)

        const obj = this.parseLink(response.headers.link)
        if (obj['next']) {
            data = await this.getDataRecursive(obj['next'], {}, func, data);
        }

        return data;
    }
}

export default new CallHelper();
